import Menu from '@mui/icons-material/Menu';
import classNames from 'classnames';
import { useAppContext } from 'components/common/AppProvider';
import { HeaderList } from 'components/Layout/Header/HeaderList';
import { HeaderLogo } from 'components/Layout/Header/HeaderLogo';
import { SgwtAccountCenter } from 'components/Layout/Header/SgwtAccountCenter';
import React, { useEffect, useRef, useState } from 'react';
import { getAppContext } from 'store/AppContext/AppContextThunk';
import { FranfinanceSelectors } from 'store/Normalizr/Selectors';

export const Header: React.FC = () => {
    const { dispatch, state: { appContext: { loggedUserId }, entities } } = useAppContext();
    const loggedUser = FranfinanceSelectors.getLoggedUser(loggedUserId, entities.franFinance);

    const [dropdownOpen, setDropdownOpen] = useState(false);
    const toggle = () => setDropdownOpen((prevState) => !prevState);
    const headerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        dispatch(getAppContext()).catch(() => void 0);
        const close = () => setDropdownOpen(false);
        const clickoutClose = (ev: MouseEvent) => {
            if (ev.target && !headerRef?.current?.contains(ev.target as Node)) {
                close();
            }
        };

        window.addEventListener('click', clickoutClose);
        return () => {
            window.removeEventListener('click', clickoutClose);
        };
    }, [setDropdownOpen]);

    return <header className="sticky-top bg-lvl1" ref={headerRef}>
        <nav className="navbar">
            <div className="navbar-title">
                <HeaderLogo />
                {loggedUser && <>
                    <button className={classNames('d-lg-none navbar-menu-btn btn btn-flat btn-xl btn-icon flex-center', { show: dropdownOpen })} onClick={toggle}>
                        <Menu className="icon" fontSize="large" />
                    </button>
                    <HeaderList toggle={toggle} className={classNames('bg-lvl2 navbar-menu-dropdown dropdown-menu w-100', { show: dropdownOpen })} />
                </>}
            </div>

            <div className="navbar-content">
                {loggedUser && <HeaderList className="navbar-navigation m-0" />}

                <div className="d-block flex-grow-1"></div>

                <SgwtAccountCenter />
            </div>
        </nav>
    </header>;
};
